import Table from "../../table/Table";
import { useState, useEffect, useCallback } from "react";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { Configuration, chackTitle } from "../../../constants";
import { Button } from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Container, Card } from "reactstrap";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { routes } from "../../../routers/routes";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";

const Chack = () => {

    
    const role = useAppSelector((state: any) => state.role.role);
    const navigate = useNavigate();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedChackId, setSelectedChackId] = useState("");

    
    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        searchQuery,
        setSearchQuery,
        filterOn,
        setSortBy,
    } = usePagination({
        endpoint: `/chack`,
        filterOn:'ChackName',
        enabled:true
        
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])

    /*useEffect(()=>{
        const fetchChackDetails = async () => {
            try {
                const response = await ApiService.axiosApi('/chack',{
                    method:"GET"
                });
                if(response.success){
                    console.log(response.data);
                    setChackDetails(response.data);
                }else{
                    toast.error(response.message||"unable to fetch user detail");
                }
            } catch (error) {
                console.log(error);
            }
        }   
        fetchChackDetails();
    },[refresh])*/

    const handleDeleteChack = async (selectedChackId: string) => {
        try {
            const response = await ApiService.axiosApi(`/chack/${selectedChackId}`, {
                method: "DELETE"
            });
            if (response.success) {
                toast.success(response.data.message);
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev);
            } else {
                toast.error(response.data.message);
            }

        } catch (error: any) {
            toast.error(error.message);
        }

    }

    const handleChackUpdate = (id: string) => {
        navigate(`/chack-update/${id}`);
    }
    const handleDelete = (id: string) => {
        setSelectedChackId(id);
        setIsDeleteModalOpen(true);
    }



    return (

        <>
            <Breadcrumbs mainTitle={chackTitle} parent={Configuration} />
            <div className="tables" >
                <Card>
                    <CommonCardHeader title="Chak List" headClass="pb-3" />
                    <div className="d-flex justify-content-between">

                    <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                      
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('ChackName')}>
                         <FilterIcon/>
                       </button>
                           </div>
                        
                    </div>
                    
                    {role === "Administrator" && (
                        <div className="d-flex justify-content-end " >
                            <Button onClick={() => navigate(routes.ChackAdd)} color="primary" className="mb-2 mx-2">Add Chak</Button>
                        </div>
                    )}
                    </div>

                    <Table data={data} columns={[
                        { header: "Chak Name", accessor: "chackName" },
                        { header: "Chak Area", accessor: "chackArea" },
                        { header: "Duty", accessor: "duty" },
                        { header: "PCFRV Scada Control", accessor: "pcfrV_ScadaControl" },
                        { header: "No of Onof Valves", accessor: "no_Of_ON_OF_Valves" },
                        { header: "Scheme/Village", accessor: "scheme_Village" },
                        { header: "Distributary/Zone", accessor: "distributary_Zone" },
                        { header: "Chak Leader", accessor: "chackLeader" },
                        { header: "Chak Mobile", accessor: "chackLeader_MobileNumber" },
                        { header: "Long", accessor: "long" },
                        { header: "Lat", accessor: "lat" },
                        { header: "Duid", accessor: "duid" },
                        {header:"HeadQuater Of WUA", accessor:"headQuaterName"}
                    ]}
                        buttons={[
                            { label: "Edit", onClick: handleChackUpdate, color: "primary", className: "me-2" },
                            { label: "Delete", onClick: handleDelete, color: "danger" }
                        ]}
                    />
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>

                </Card>
                <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                    <ModalHeader>Delete Chack</ModalHeader>
                    <ModalBody>Are you sure you want to delete this chak?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteChack(selectedChackId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </>

    )
}
export default Chack;
